import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidatorsService } from 'src/app/services';

@Component({
  selector: 'app-eds',
  templateUrl: './eds.component.html',
  styleUrls: ['./eds.component.css']
})
export class EdsComponent implements OnInit {

  signData: boolean = false; // временно
  noData: boolean = false; 
  signedXmls: string[] = [];
  xmlsToSign: string[] = [];
  profileForm: UntypedFormGroup; 

  @Input() set data(value: string[]){

    this.xmlsToSign = [];
    this.signedXmls = [];
    
    if(value != null && value.length > 0 && value[0]){
      
      this.xmlsToSign = value;
      this.noData = false;
      this.initForm();
      this.addFieldsWithData();
    }
    else{

      this.noData = true;
      this.xmlsToSign = [];
      this.initForm();
    }
  }

  constructor(
    private fb: UntypedFormBuilder,
    private validatorsService: ValidatorsService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {}


  /**
   * 
   */
  initForm(): void {

    this.profileForm = this.fb.group({
      matStorageSelect: [''],
      storageSelect:    ['PKCS12', Validators.required],
      xmlsToSign:       this.fb.array([]),
      signedXmls:       this.fb.array([])
    });
  }


  /**
   * 
   * @param data 
   */
  initFormSetSignXmls(data: any){
    
    return this.fb.group({
      value: [data, Validators.required],
    });
  }


  /**
   * 
   */
  initFormSetSignedXmls(){
    
    return this.fb.group({
      value: [''],
    });
  }

  
  /**
   * 
   */
  addFieldsWithData(): void {

    const control1 = <UntypedFormArray>this.profileForm.controls['xmlsToSign'];
    const control2 = <UntypedFormArray>this.profileForm.controls['signedXmls'];
    
    for (let xml of this.xmlsToSign) {

      control1.push(this.initFormSetSignXmls(xml));
      control2.push(this.initFormSetSignedXmls());
    }
  }


  /**
   * 
   * @param val 
   */
  sendSignedXml(val): void { 

    this.signedXmls.push(val);
    this.activeModal.close(this.signedXmls);
  }

}
